<template>
  <div class="classification">
    <div class="eachRow">
      <div class="titleView">
        <div class="rowLine"></div>
        <span class="eachRowTitle">投诉建议</span>
        <span class="right"
              @click="clickAdd">新建</span>
      </div>
      <div class="content">
        <div v-for="(item,index) in data"
             :key="index">
          <div class="title">
            <span class="pingtai">{{ item.createBy }} </span>
            <span>{{ item.createTime }}</span>
          </div>
          <p class="detail">{{ item.adviseInfo }}</p>
          <ImgUpload v-model="item.image"
                     :limit="5"
                     :isEdit="true"
                     style="position:relative;top:-8px">
            <!-- <template slot="tip">
              <p class="el-upload__tip"
                 style="margin:0px">
                备注:图片格式为jpg或png，建议尺寸100*100，图片大小不得超过5M
              </p>
            </template> -->
          </ImgUpload>
          <el-divider></el-divider>
        </div>

      </div>
    </div>
  </div>
</template>
  
<script>
import ImgUpload from '@/components/imgUpload'
import { page, insert, list } from '@/api/suggestion'
export default {
  props: {},
  data () {
    return {
      shopId: '',
      data: []
    }
  },
  components: { ImgUpload },
  created () {
    this.shopId = this.$route.query.shopId || ''
    this.list()
  },
  mounted () {

  },
  watch: {},
  methods: {
    list () {
      list({
        shopId: this.shopId
      }).then(res => {
        if (res.code == 0) {
          // console.log(res.data)
          this.data = res.data
          this.data.forEach(item => {
            if (item.image) {
              item.image = item.image.split(',')
            }
          })
        } else {
          this.data = []
        }
      })
    },
    clickAdd () {
      this.$router.push({ path: '/business/suggestion-add', query: { shopId: this.shopId } })
    }
  }
}

</script>
<style lang="scss" scoped>
.eachRow {
  // height: calc(100% - 24px);
  // overflow: auto;
  margin-top: 24px;
}
.titleView {
  display: flex;
  align-items: center;
  position: relative;

  .rowLine {
    width: 4px;
    border-color: 1px;
    background-color: var(--main-color);
    height: 16px;
    margin-right: 8px;
  }

  .eachRowTitle {
    font-size: 16px;
    color: #262626;
    font-weight: 600;
  }
  .right {
    font-size: 16px;
    position: absolute;
    right: 0px;
    color: #f5222d;
    cursor: pointer;
  }
}
.content {
  height: calc(100% - 19px);
  overflow: auto;
  .title {
    padding: 16px 0px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .pingtai {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .detail {
    //中英文强制换行
    word-break: break-all;
    word-wrap: break-word;

  }
}
</style>
